import React from "react";
import { Link } from "react-router-dom";
import { resolveImage } from "@/lib/api";
import { motion } from "framer-motion";

const ProductCard = ({ product, index = 0 }) => {
  const img = product.images?.[0]
    ? resolveImage(product.images[0])
    : "https://images.unsplash.com/photo-1705326454924-f6777522b030?w=600&fit=crop";
  const hasMrp = product.mrp && product.mrp > product.selling_price;
  const isLowStock =
    product.availability === "in_stock" &&
    typeof product.stock_quantity === "number" &&
    product.stock_quantity > 0 &&
    product.stock_quantity <= 5;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.04, 0.4), duration: 0.35 }}
    >
      <Link
        to={product.slug ? `/p/${product.slug}` : `/product/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="block group press"
      >
        <div
          className="aspect-[4/5] rounded-2xl overflow-hidden relative"
          style={{ background: "#F1E8D8" }}
        >
          <img
            src={img}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          />
          {product.availability === "out_of_stock" && (
            <div
              className="absolute top-2 left-2 text-[9px] tracking-editorial-sm uppercase px-2 py-1 rounded-full"
              style={{ background: "rgba(244,237,226,0.9)", color: "var(--ink)" }}
            >
              Sold out
            </div>
          )}
          {isLowStock && (
            <div
              data-testid={`low-stock-${product.id}`}
              className="absolute top-2 left-2 text-[9px] tracking-editorial-sm uppercase px-2 py-1 rounded-full chip-accent"
            >
              Only {product.stock_quantity} left
            </div>
          )}
        </div>
        <div className="mt-3 px-0.5">
          {product.brand && (
            <div
              className="text-[9px] tracking-editorial-sm uppercase truncate"
              style={{ color: "var(--ink-3)" }}
            >
              {product.brand}
            </div>
          )}
          <div
            className="font-display text-[15px] leading-tight truncate mt-0.5"
            style={{ color: "var(--ink)" }}
          >
            {product.name}
          </div>
          <div className="flex items-baseline gap-2 mt-1.5">
            <span
              className="font-display-italic text-[15px]"
              style={{ color: "var(--accent)" }}
            >
              ₹{Math.round(product.selling_price)}
            </span>
            {hasMrp && (
              <span className="text-[11px] line-through" style={{ color: "var(--ink-3)" }}>
                ₹{Math.round(product.mrp)}
              </span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
